export default "__VITE_ASSET__5ofKgElw__"